import { render, staticRenderFns } from "./ModalAdminList.vue?vue&type=template&id=4bce2c98&scoped=true"
import script from "./ModalAdminList.vue?vue&type=script&lang=js"
export * from "./ModalAdminList.vue?vue&type=script&lang=js"
import style0 from "./ModalAdminList.vue?vue&type=style&index=0&id=4bce2c98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bce2c98",
  null
  
)

export default component.exports